import { Modal, Platform } from 'react-native';

import WebModal from 'modal-react-native-web';

const CustomModal = Platform.select({
  ios: () => Modal,
  android: () => Modal,
  default: () => WebModal,
})();

export default CustomModal;
